<template>
  <div>
    <v-navigation-drawer
      v-model="isOpen"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="isOpen"
      hide-overlay
      class="z-index--100 pl-4"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="isOpen" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column py-4">
          <div>
            <v-data-table
              :loading-text="tableOtherInvoices.loadingText"
              :loading="tableOtherInvoices.loading"
              :headers="tableOtherInvoices.headers"
              :items="tableOtherInvoices.data"
              :options="tableOtherInvoices.options"
              class="tableBilling"
            >
              <template v-slot:[`item.date`]="{ item }">
                {{ $moment(item.issuedAt).format('MMMM') }}
              </template>
              <template v-slot:[`item.client`]="{ item }">
                <div>{{ item.receiverTaxid }}</div>
              </template>
              <template v-slot:[`header.amount`]="{ header }">
                <div class="text-right">{{ header.text }}</div>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <div class="text-right">{{ formatCurrency(item.total) }}</div>
              </template>
              <template v-slot:[`item.category`]="{ item }">
                <div>{{ getCategoryName(item.incomeType ? item.incomeType._id : undefined) }}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <!-- <InvoiceViewer ref="invoiceViewer" /> -->

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'OtherInvoices',
  props: {
    selectedDates: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data () {
    return {
      overlay: false,
      tableOtherInvoices: {
        loadingText: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.loading'),
        loading: false,
        headers: [
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.date'), value: 'date', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.client'), value: 'client', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.amount'), value: 'amount', sortable: false },
          { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.category'), value: 'category', sortable: false }
          // { text: this.$i18n.t('income.billing.otherInvoices.tableOtherInvoices.headers.support'), value: 'support', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      categories: [],
      dates: [],
      isOpen: false
    }
  },
  async mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
    await this.loadOtherInvoices()
    await this.loadCategories()
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  watch: {
    async isOpen (val) {
      await this.updateDates(this.selectedDates)
    }
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.isOpen = false
    },
    closePanel () {
      this.isOpen = false
    },
    updateDates (dates) {
      this.selectedDates = [ ...dates ]
      this.loadOtherInvoices()
    },
    async loadOtherInvoices () {
      if (this.selectedDates.length === 2) {
        const [startDate, endDate] = this.selectedDates
        const params = {
          'issuedAt>': startDate,
          'issuedAt<': endDate
        }
        this.tableOtherInvoices.loading = true
        try {
          const response = await this.$api.get(`/v1/restaurants/income/invoices`, params)
          this.tableOtherInvoices.data = response.data
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.tableOtherInvoices.loading = false
      }
    },
    formatCurrency,
    async loadCategories (params = null) {
      params = params || {
        type: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.categories = response.data
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getCategoryName (id) {
      const category = this.categories.find(item => item._id === id)
      return category ? category.name : undefined
    },
    open () {
      this.isOpen = true
    }
  }
}

</script>

<style lang="scss" scoped>
  .paper {
    display: flex;
    padding: 40px 50px 50px 57px;
    border-radius: 26px;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
  }

  .linkButton {
    &:hover {
      a {
        text-decoration: underline;
      }
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>

<style lang="scss">
  .tableBilling {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }
</style>
